// @flow

export default class ObjectHelper {
    static mapValues(obj: {}, fn: Function) {
        let result = {};
        Object.keys(obj).forEach(key => {
            result[key] = fn(obj[key]);
        });
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/util/ObjectHelper.js